export function normalizeBusinessType(type) {
  if (!type) return "restaurant";
  const lower = String(type).toLowerCase().trim();
  if (lower === "raw_food" || lower === "raw_foods" || lower === "wholesale") {
    return "wholesale";
  }
  if (lower === "store" || lower === "stores" || lower === "retail") {
    return "retail";
  }
  return "restaurant";
}

export function getBusinessDisplayTitle(type) {
  const norm = normalizeBusinessType(type);
  if (norm === "wholesale") return "Wholesale";
  if (norm === "retail") return "Retail";
  return "Restaurant";
}
